import { createPinia, defineStore, setActivePinia } from 'pinia';
import { getCurrentUser } from '@/service/Users';
import ErrorCatch from '../service/ErrorCatch';

const pinia = createPinia();
setActivePinia(pinia);

const isFeatureEnabled = (value) => value === true || value === 'true' || value === 1 || value === '1';

export const useUserStore = defineStore('user', {
  state: () => ({
    userId: null,
    user: {},
    roles: [],
    isAdmin: false,
    hasSalesJobFunction: false,
    salesforceEnabled: false,
    rolesAssociatedCurrentUserBrand: [],
    homePath: '',
  }),
  actions: {
    async fetchUser() {
      try {
        let response = await getCurrentUser();
        this.userId = response.id;

        if (response.status === 500) {
          return response;
        }

        this.user = response.user;
        this.roles = response.roles;
        this.isAdmin = response.admin;
        this.hasSalesJobFunction = this.user.job_function === 'Sales' || this.user.job_function === 'Sales (Other)';
        this.salesforceEnabled = isFeatureEnabled(
          response.features?.salesforce_enabled ?? response.salesforce_enabled
        );
      } catch (error) {
        ErrorCatch(error);
      }
    },
    getBrandRoles(brandName) {
      const rolesAssociated = [];

      for (let i = 0; i < this.roles.length; i++) {
        if (brandName === this.roles[i].brand) {
          rolesAssociated.push(this.roles[i].name);
        }
      }

      this.rolesAssociatedCurrentUserBrand = rolesAssociated;

      return rolesAssociated;
    },
    setUserHomePath() {
      if (this.isAdmin) {
        this.homePath = '/';
      } else {
        let defaultPathAccess = false;

        if (this.roles.length === 0) {
          this.homePath = '/no_dashboard_access';
          defaultPathAccess = true;
        } else {
          for (let i = 0; i < this.roles.length; i++) {
            const role = this.roles[i];
            if (role.name === 'General Manager' || role.name === 'Leadership Viewer' || role.name === 'Sales Director' || role.name === 'Sales Support' || role.name === 'Controller') {
              this.homePath = '/' + role.brand_slug;
              defaultPathAccess = true;
              break;
            }
            if (role.name === 'Corporate Accounting' || role.name === 'Strategic Account' || (this.roles.length === 0 && role.name === 'MBUP')) {
              this.homePath = '/no_dashboard_access';
              defaultPathAccess = true;
              break;
            }
          }
        }

        if (!defaultPathAccess) {
          this.homePath = '/users/' + this.userId + '/dashboard';
        }
      }
    },
  },
});
